import { Component, OnInit } from '@angular/core';
import {Categorymaster} from "../models/categorymaster";
import {CategoryService} from "../services/category.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
declare var $ :any;
declare var bootbox: any;


@Component({
  selector: 'app-categorylist',
  templateUrl: './categorylist.component.html'
})
export class CategorylistComponent implements OnInit {

    p: number[] = [];
    searchText: string = ''; 
    categorylist:Categorymaster[];

    constructor(
        private categoryService:CategoryService,
        private router:Router,
    ) { }

    ngOnInit() {
        this.getCategories(0,{sortColumn: 'category_id', sortDirection:'desc'});
        // $(document).ready(function() {
        //     $("#datatable").DataTable();
        // });
    }

    onSorted($event){
        this.getCategories(0,$event);
    }

    getCategories=function(pageId,criteria: CategoryListSearchCriteria){
        this.categoryService.getCategoryList(pageId,this.searchText).then(data => {
            console.log("CategoryList =======>",data);
            this.categorylist = data['data']['data'];
            this.totaloffset = data['data'].Totaloffset;
            this.itemsperpage = data['data'].ItemsPerPage;
            this.SortCategories(criteria);     
        });
    }

    SortCategories(criteria: CategoryListSearchCriteria): Categorymaster[] {
        return this.categorylist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    viewCategory(category_id){
        this.router.navigate(['/categories/',category_id]);
    }

    viewCards(category_id){
        this.router.navigate(['/categories/cards/',category_id]);
    }

    deleteCategory(category_id,i){
        this.categoryService.deleteCategoryCall(category_id).then(data => {
            console.log(data['code'])
            if(data['code'] === 200){
                $.toast({heading: 'Success', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getCategories(0,{sortColumn: 'name', sortDirection:'desc'});
                // this.router.navigate(['/categories']);
            }else{
                $.toast({heading: 'Warning', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deleteCategoryConfirm(category_id,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deleteCategory(category_id,i);
                }
            }
        });
    }

}

export class CategoryListSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/categoriesmaster/categorylist/categorylist.component.ts